import React, { CSSProperties, FC, PropsWithChildren } from 'react'

import {
  TooltipWrapper,
  TooltipElement,
} from 'components/presentational/Tooltip/Tooltip.styled'
import {
  Position,
  TextPosition,
} from 'components/presentational/Tooltip/Tooltip.types'

export const Tooltip: FC<
  {
    width: number
    position: Position
    textPosition: TextPosition
    indent: number
    zIndex?: number
    wrapperStyles?: CSSProperties
  } & PropsWithChildren
> = ({
  children,
  width = 200,
  position = Position.TopLeft,
  textPosition,
  indent,
  zIndex,
  wrapperStyles,
}) => {
  return (
    <TooltipElement $position={position} $indent={indent} $zIndex={zIndex}>
      <TooltipWrapper
        style={wrapperStyles}
        $width={width}
        $position={position}
        $textPosition={textPosition}
        $withArrow={true}
        $indent={indent}
      >
        {children}
      </TooltipWrapper>
    </TooltipElement>
  )
}
